module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_3-7479931ec96d924ff5a8dc8ee6fbcd23.jpeg";